// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingSpinner_wrapper__LIwYR","spinner":"LoadingSpinner_spinner__5oLBy","spin":"LoadingSpinner_spin__h7N50"};